<template>
  <div
    class="c-variant-title t-paragraph-medium"
    :class="[
      'l-flex',
      'l-flex--column',
      'l-flex--align-start',
    ]"
  >
    <!-- display line item properties -->
    <div
      v-for="variantProp in variantProps"
      :key="variantProp.label"
      class="c-variant-title__prop u-margin-bottom-xx-small"
    >
      <template v-if="variantProp.label && variantProp.value">
        <div class="l-flex">
          <ul>
            <li>
              <p class="c-variant-title__prop-label t-paragraph-medium--base">
                {{ variantProp.label | capitalize }}:
              </p>
            </li>
          </ul>
          <ul>
            <li>
              <p
                class="c-variant-title__prop-value"
                :style="variantProp.style"
              >
                {{ variantProp.value }}
              </p>
            </li>
          </ul>
        </div>
      </template>
      <span
        v-else
        class="c-variant-title__prop-label"
      >
        {{ variantProp.label }}
      </span>
    </div>
    <!-- edit engraving -->
    <div
      v-if="canEditEngraving"
      class="c-variant-title__edit-engraving l-flex"
    >
      <button
        title="Edit engraving."
        class="c-variant-title__button c-variant-title__button-edit"
        :class="[
          'l-flex',
          'l-flex--align-center',
          'l-flex__nowrap'
        ]"
        @click="editEngraving"
      >
      <img
          class="c-variant-title__crud-icon"
          src="~assets/icons/pencil.svg"
          alt="edit"
        >
        <span class="t-paragraph-medium">Edit Engraving</span>
      </button>
      <button
        title="Remove engraving."
        class="c-variant-title__button  c-variant-title__button-remove"
        :class="[
          'l-flex',
          'l-flex--align-center',
          'l-flex__nowrap'
        ]"
        @click="deleteEngraving(item)"
        >
        <img
          class="c-variant-title__crud-icon"
          src="~assets/icons/default-close-icon-red.svg"
          alt="remove"
        >
        <span class="t-paragraph-medium c-variant-title__button-remove">Remove</span>
      </button>
    </div>
    <!-- engraving cta -->
    <div
      v-else-if="wantsEngraving"
      class="c-variant-title__engraving-cta"
    >
      <button
        aria-label="Add or edit engraving."
        class="c-variant-title__engraving-cta-button t-heading-7"
        @click="editEngraving"
      >
        <span>
          &#x2b; Add Engraving
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import intersection from 'lodash/intersection'
import capitalize from 'lodash/capitalize'
import { mapState, mapActions, mapMutations } from 'vuex'
import ProductPrice from '@/components/productPrice/ProductPrice'
export default {
  filters: {
    capitalize: value => (value ? capitalize(value) : '')
  },
  components: {
    ProductPrice
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    engravingFee: {
      type: Object,
      default: () => ({})
    },
    sleeveFee: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapState('engraving', ['engravingKeys']),
    engravingFont() {
      let result
      const item = this.item
      if (item.customAttributes) {
        for (let { key, value } of item.customAttributes) {
          if (key && (key === 'font')) {
            result = value
            break
          }
        }
      }
      return result
    },
    engravingDiscount() {
      return Math.ceil((this.engravingFee.price * Number(this.item.customAttributes.find((obj)=>obj.key == '_engravingDiscount').value)))
    },
    variantProps() {
      const engravingFont = this.engravingFont
      const item = this.item
      const title = this.title
      let result = []
      if (item) {
        const variantTitle = get(item, 'variant.title') || title
        if (item.customAttributes) {
          for (let { key, value } of item.customAttributes) {
            if (key && !key.startsWith('_')) {
              let prop = { label: key, value }
              if ((key === 'font') || (key === 'text')) {
                prop.style = { 'font-family': `Enso ${engravingFont}` }
              }
              result.push(prop)
            }
          }
        }
      }
      return result
    },
    canEditEngraving() {
      const engravingKeys = this.engravingKeys
      const wantsEngraving = this.wantsEngraving
      const variantProps = this.variantProps
      let keys = []
      for (let { label } of variantProps) {
        keys.push(label)
      }
      return wantsEngraving && intersection(keys, engravingKeys).length > 0
    },
    wantsEngraving() {
      return !!get(this.item, 'metafieldsMap.engraving.value')
    },
    hasSleeveFee() {
      let result = false;
      for (let attr of this.item.customAttributes) {
        if (attr.key === 'sleeve') {
          result = true;
        }
      }
      return result;
    }
  },
  methods: {
    ...mapActions('engraving', {
      openEngraving: 'open',
      setEngravingContext: 'setContext',
      deleteEngraving: 'deleteEngraving',
      activeOfferProps: 'activeOfferProps',
    }),
    ...mapMutations('cart', [ 'hideCart' ]),
    async editEngraving() {
      await this.setEngravingContext({
        product: this.item,
        variant: this.item.variant
      })
      this.openEngraving()
      this.hideCart()
    }
  }
}
</script>

<style lang="scss" scoped>
.c-variant-title {
  &__button {
    border: none;
    background: none;
    min-width: rem(20px);
    height: rem(20px);
    &:hover {
      cursor: pointer;
    }
    &-edit {
      border: solid black 1px;
      padding: rem(15px);
      margin-right: rem(20px);
    }
    &-remove {
      @include themify($themes) {
        color: themed('foreground', 'error');
      }
      svg > g {
        @include themify($themes) {
          stroke: themed('foreground', 'error');
        }
      }
    }
  }
  &__crud-icon {
    width: rem(12px);
    height: rem(12px);
    margin-right: rem(4px);
  }
  &__cta-icon {
    margin-right: rem(10px);
  }
  &__prop-value {
    text-transform: none;
  }
  &__engraving-cta-button {
    border: none;
    animation: alertPulse 2s ease-out;
    animation-iteration-count: 2;
    animation-duration: 1.5s;
    background-color: transparent;
    transition: background 275ms ease;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    border-radius: 25px;
    padding: 10px 25px 10px 10px;
    margin-bottom: 0px;

    &:hover {
      cursor: pointer;
    }

    span {
      margin-right: rem(12px);
    }
  }
  &__prop ul {
    list-style: none;
  }
  &__prop-label {
    font-weight: 800;
    width: rem(100px);
  }
}
</style>
